import * as React from "react";
const SafeReact = {
  ...React
};
export {
  SafeReact
};
//# sourceMappingURL=safeReact.js.map
